import { gql } from "@/__generated__/gql";

export const BAN_FROM_ORG_MUTATION = gql(`
mutation banFromOrg($orgId:ID!, $userId:ID!){
    createBannedFromOrg(input:{
      organizationId:$orgId,
      userId:$userId
    }){
      clientMutationId
      errors{
        message
        title
      }
    }
  }
  `);
